import styled from 'styled-components';

import { getTheme } from 'lib/styles/getTheme';

export const Select = styled.select`
  font-family: ${getTheme('text.fontFamily')};
`;
